
const constants = Object.freeze({
    API_URL: process.env.API_URL,
    TIME_TO_LOGIN_PIN: 86400, //sec
    PIN_ATTEMPT: 5
});
export default constants;



// WEBPACK FOOTER //
// ./src/common/constants.js